module.exports = __webpack_public_path__ + "img/ent-server.58dc8f54.jpg";